import { firebaseConfig } from '@/firebase';

const functionsRegion = 'europe-west3';
const unsubscribeFunctionName = 'unsubscribeNewsletter';

const unsubscribeNewsletterEndpoint = () => {
  const projectId = firebaseConfig.projectId;
  if (!projectId) throw new Error('Firebase project ID is required.');

  if (import.meta.env.VITE_USE_EMULATORS === 'true') {
    return `http://127.0.0.1:5001/${projectId}/${functionsRegion}/${unsubscribeFunctionName}`;
  }

  return `https://${functionsRegion}-${projectId}.cloudfunctions.net/${unsubscribeFunctionName}`;
};

const isGenericSuccess = (value: unknown): value is { ok: true } =>
  Boolean(value) &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  (value as Record<string, unknown>).ok === true;

/** Sends the opaque unsubscribe capability only after the visitor confirms it. */
export const unsubscribeNewsletter = async (token: string): Promise<void> => {
  const response = await fetch(unsubscribeNewsletterEndpoint(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });

  if (!response.ok || !isGenericSuccess(await response.json())) {
    throw new Error('Newsletter unsubscribe request failed.');
  }
};
